export const frNotifications = {
    // NOTIFICATIONS
    'notifications.type.undefined': 'Publication',
    'notifications.type.manual': 'Manuelle',
    'notifications.type.onetime': 'Une fois',
    'notifications.type.recurrent': 'Récurrente',
    'notifications.type.on_publish': 'À la publication',
    'notifications.type.on_audience_changed': "Changement d'audience",
    'notifications.type.on_end_date_changed': "Changement de date d'échéance",
    'notifications.type.too_late': 'Fin',
    'notifications.type.start_tomorrow': 'Début demain',
    'notifications.type.start_today': 'Début',
    'notifications.type.on_event': 'Récurrente',
};
